exports.participationLabel = 'Participate in points, medals, and leaderboards';
